import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ImproveContentTypePopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "ImproveContentTypePopup" */ './Container'),
  'popup'
);
